import React from 'react';
import { 
  HelpCircle, 
  Heart, 
  Activity, 
  Clock, 
  User,
  Calendar, 
  RefreshCw, 
  BarChart
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Heart,
      title: 'Правильное измерение пульса',
      description: 'Измеряйте пульс в покое утром сразу после пробуждения. Для тренировок используйте пульсометр.'
    },
    {
      icon: Clock,
      title: 'Восстановление пульса',
      description: 'Скорость восстановления пульса после нагрузки — важный показатель здоровья. Он должен снизиться на 15-20% за первую минуту отдыха.'
    },
    {
      icon: Activity,
      title: 'Тренировочные зоны',
      description: 'Чередуйте тренировки в разных зонах. Большая часть (около 70-80%) должна проходить в зонах 1-2.'
    },
    {
      icon: Calendar,
      title: 'Регулярность',
      description: 'Тренируйтесь регулярно 3-5 раз в неделю для эффективного развития сердечно-сосудистой системы.'
    },
    {
      icon: RefreshCw,
      title: 'Периодизация нагрузок',
      description: 'Чередуйте недели интенсивных и легких тренировок для правильного восстановления и прогресса.'
    },
    {
      icon: BarChart,
      title: 'Контроль прогресса',
      description: 'Отслеживайте свои показатели: пульс покоя должен снижаться со временем при регулярных тренировках.'
    },
    {
      icon: User,
      title: 'Индивидуальный подход',
      description: 'Учитывайте свои особенности: формулы дают приблизительные значения, которые можно корректировать.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-red-500" />
        Советы по тренировкам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Heart className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-red-700 dark:text-red-300 mb-2">
              Персональная консультация
            </h4>
            <p className="text-xs text-red-600 dark:text-red-400 mb-3">
              Для составления индивидуальной программы тренировок по пульсу обратитесь к специалисту по спортивной медицине или персональному тренеру.
            </p>
            <button className="w-full py-1.5 text-xs bg-red-500 text-white rounded hover:bg-red-600 transition-colors">
              Найти специалиста
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;